import * as stylex from "@stylexjs/stylex";

export const breakpoints = stylex.defineConsts({
  s: "@media (min-width: 600px)",
  m: "@media (min-width: 900px)",
  l: "@media (min-width: 1200px)",
});

export const colors = stylex.defineConsts({
  unescoMarineBlue: "#0075D1",
  unescoMarineBlueDark: "#005192",
  unescoMainBlue: "#0069B4",
  unescoMainGreen: "#23B850",
  grayscale1: "#FAFAFA",
  grayscale2: "#F5F5F5",
  grayscale3: "#EBEBEB",
  grayscale4: "#DDDDDD",
  blackText: "#333333",
  blackTextFade10: "rgba(51, 51, 51, 0.1)",
  lightText: "#585858",
  unescoDarkBlue: "#23305f",
  unescoDarkBlueDark: "#182142",
  divider: "#DDDDDD",
  whiteText: "#FFFFFF",
  unescoDarkRed: "#C72031",
  unescoTeal: "#00A99D",
  unescoTealDark: "rgb(0, 118, 109)",
});

export const zIndex = stylex.defineConsts({
  aside: 1,
  tooltip: 10,
  overlapContext: 11,
  header: 20,
});

export const layoutAreas = stylex.defineConsts({
  full: "full-start / full-end",
  fullStart: "full-start",
  fullEnd: "full-end",
  main: "main-start / main-end",
  mainStart: "main-start",
  mainEnd: "main-end",
  side: "side-start / side-end",
  sideStart: "side-start",
  sideEnd: "side-end",
  figure: "figure-start / figure-end",
  figureStart: "figure-start",
  figureEnd: "figure-end",
  wide: "wide-start / wide-end",
  wideStart: "wide-start",
  wideEnd: "wide-end",
  center: "center-start / center-end",
  centerStart: "center-start",
  centerEnd: "center-end",
});
